import React, { Component } from "react";
import { connect } from "react-redux";
import SurveyCreationSteps from "./../../components/survey/SurveyCreationSteps";
import {
	addStepSurvey,
	getByIdClient,
} from "./../../redux/actions/surveyActions";
import {
	setMenuLeftContent,
	setMenuLeftIndex,
	setMenuLeftItemIndex,
	setMenuTopIndex,
} from "../../redux/actions/menuActions";
import MenuActivite from "../activite/Menu";

class CreationSteps extends Component {
	componentDidMount() {
		this.props.setMenuLeftIndex("createSurvey");

		this.props.setMenuTopIndex("activite");
		this.props.setMenuLeftContent(MenuActivite);
		this.props.setMenuLeftIndex("questionnaire");
		this.props.setMenuLeftItemIndex("surveyCreate");
	}
	render() {
		return <SurveyCreationSteps {...this.props} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		/* on recupère tous les locations et les assortmentClient du client du mamager */
		locations: state.survey.surveyManager.locations,
		modelList: state.survey.surveyManager.modeleList,
		assortmentClient: state.survey.surveyManager.assortmentClient,
		currentClient: state.currentClient || {},
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		getByIdClient: idClient => {
			dispatch(getByIdClient(idClient));
		},
		/* Cette fonction permet de definir l'action addStepSurvey qui va piloté la mise à jour avec redux */
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		setMenuLeftIndex: index => {
			dispatch(setMenuLeftIndex(index));
		},
		setMenuLeftItemIndex: index => {
			dispatch(setMenuLeftItemIndex(index));
		},
		setMenuLeftContent: content => {
			dispatch(setMenuLeftContent(content));
		},
		setMenuTopIndex: index => {
			dispatch(setMenuTopIndex(index));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CreationSteps);



// WEBPACK FOOTER //
// src/pages/survey/CreationSteps.js